const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class ArticlesCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            loop: true,
            slides: {
              origin: 'center',
              perView: 1.5,
              spacing: 10,
            },
          },
          '(min-width: 901px)': {
            loop: true,
            slides: {
              origin: 'center',
              perView: 2,
              spacing: 12,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('articles-carousel')) {
  customElements.define('articles-carousel', ArticlesCarousel)
}
